import React, { useState } from 'react';
import { EaseModal } from '../../../libs/EaseModal';
import { BeneficiaryForm } from '../Forms';
import { EditBeneficiaryForm } from "../Forms";
import { Text1, Text4 } from '../../../styles';
import { MerchantService } from '../../../services';
import { handleApiExceptions } from '../../../app_methods';
import { OTPModal } from '../OTPModal';


const BeneficiaryModal = (props) => {
    const renderTitle = () => {
        return (
            <div className="mb-4">
                <Text1 className="d-block" strong>
                    {`${props?.beneficiary?.is_edit ? "Update" : "Create"} Beneficiary`}
                </Text1>
                <Text4 className="d-block"><i>For {props.contact.name}</i></Text4>
            </div>
        )
    };
    
    return (
        <EaseModal
            width={props?.beneficiary?.is_edit ? 450 : 530}
            title={false}
            visible={props.visible}
            onCancel={props.toggleBeneficiaryModal}
            centered
            hideHeader
            hideFooter
            destroyOnClose
        >
            <div>
                {renderTitle()}
                {props?.beneficiary?.is_edit ? 
                    <EditBeneficiaryForm
                        beneficiary={props.beneficiary}
                        contact={props.contact}
                        loading={props.loading}
                        onSubmit={props.onSubmit}
                    />
                :
                    <BeneficiaryForm
                        beneficiary={props.beneficiary}
                        contact={props.contact}
                        loading={props.loading}
                        onSubmit={props.onSubmit}
                        renderBankOTPModal={props.renderBankOTPModal}
                        showOTPModal={props.showOTPModal}
                        renderOTPModal={props.isRenderOTPModal}
                    />
                }
                {
                    <div style={{cursor: "pointer" }} >
                     <OTPModal
                     visible={props.showOTPModal}
                     onCancel={props.toggleBankOTPModal}
                     renderBankOTPModal={props.renderBankOTPModal}
                     isBankOTP={props.isBankOTP}
                     verifyOTP={props.verifyOTP}
                     />
         
                    </div>
                }
            </div>
        </EaseModal>
    )
};

BeneficiaryModal.defaultProps = {
    // beneficiary: { beneficiary_type: "bank_account" }
}

export { BeneficiaryModal };